/**
 * Normalizes zones.zone_users from the API into a flat numeric id list (same rules as dataAPI/helpers/zoneAccess.js).
 */
export function normalizeZoneAssignedUserIds(zoneUsersParsed: unknown): number[] {
  if (zoneUsersParsed == null) return [];
  if (!Array.isArray(zoneUsersParsed)) return [];
  if (zoneUsersParsed.length > 0 && Array.isArray(zoneUsersParsed[0])) {
    return zoneUsersParsed
      .flat()
      .map((x) => Number(x))
      .filter(Number.isFinite);
  }
  return zoneUsersParsed.map((x) => Number(x)).filter(Number.isFinite);
}

export function isUserAssignedToZone(assignedIds: readonly number[], userId: number | string | undefined): boolean {
  const uid = Number(userId);
  if (!Number.isFinite(uid)) return false;
  return assignedIds.some((id) => Number(id) === uid);
}
